import gql from 'graphql-tag'

export const QUERY_GET_SALES_ESTIMATION = gql`
  query SalesEstimation(
    $page: Int
    $page_size: Int
    $sort: [String]
    $sort_direction: [SortDirection]
    $segments_ids: [ID]
    $initial_date: String!
    $final_date: String!
    $min_qnt_purchase_days: Int
    $units: [ID]
    $products: [ID]
  ) {
    salesEstimation(
      page: $page
      pageSize: $page_size
      sort: $sort
      sortDirection: $sort_direction
      segmentsIds: $segments_ids
      minQntPurchaseDays: $min_qnt_purchase_days
      initialDate: $initial_date
      finalDate: $final_date
      units: $units
      products: $products
    ) {
      records
      page
      sales {
        product {
          sku
          name
        }
        estimated_clients_count
        estimated_products_quantity_lower
        estimated_products_quantity_upper
        estimated_coupons_count
        estimated_unitary_price_lower
        estimated_unitary_price_upper
      }
    }
  }
`

export const QUERY_GET_SEGMENTATION_CLIENTS = gql`
  query GetSegmentsNumberOfClients($segments_ids: [ID!]!) {
    getSegmentsNumberOfClients(segments_ids: $segments_ids) {
      total
    }
  }
`

export const QUERY_GET_FUTURE_INACTIVE_CLIENTS = gql`
  query FutureInactiveClientsCard($segments_ids: [ID], $initial_date: String!, $final_date: String!, $min_qnt_purchase_days: Int, $units: [ID]) {
    futureInactiveClientsCard(
      segmentsIds: $segments_ids
      initialDate: $initial_date
      finalDate: $final_date
      minQntPurchaseDays: $min_qnt_purchase_days
      units: $units
    ) {
      futureInactiveClients
    }
  }
`
export const QUERY_GET_SALES_ESTIMATION_CARDS = gql`
  query SalesEstimationCards($segments_ids: [ID], $initial_date: String!, $final_date: String!, $min_qnt_purchase_days: Int, $units: [ID]) {
    salesEstimationCards(
      segmentsIds: $segments_ids
      initialDate: $initial_date
      finalDate: $final_date
      minQntPurchaseDays: $min_qnt_purchase_days
      units: $units
    ) {
      averageSalesFrequency
      clientsQuantity
    }
  }
`
